<template>
    <div style="height: calc(100% - 55px);">
        <div class="bg-gray-50 border-b border-gray-300" style="height: 55px;">
            <div class="mx-4 flex justify-between h-full">
                <div class="flex items-center">
                    <h1 class="text-xl font-bold">Sites</h1>
                    <div class="ml-2 flex items-center text-gray-600">
                        <div class="text-base">/</div>
                        <div class="ml-2 text-base">{{ reatlas.sites.filtered.length }} of {{ reatlas.sites.all.length }}</div>
                    </div>
                    <div class="relative ml-5 bg-gray-200 p-1 rounded-lg items-center sm:flex">
                        <button
                            @click="setView('site')"
                            type="button"
                            :class="{ 'ml-0.5 bg-white': reatlas.layout == 'site' }"
                            class="p-2 rounded-md shadow-sm text-xs text-gray-500 font-semibold hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition duration-150 ease-in">
                                Sites
                        </button>
                        <button
                            @click="setView('projects')"
                            type="button"
                            :class="{ 'ml-0.5 bg-white': reatlas.layout == 'projects' }"
                            class="p-2 rounded-md text-xs text-gray-500 font-semibold hover:bg-gray-100 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition duration-150 ease-in">
                                Projects
                        </button>
                    </div>

                    <div v-if="reatlas.layout == 'projects'" class="ml-4 flex items-center">
                        <div v-if="loading" class="flex items-center">
                            <inline-svg name="loading" />
                            <span class="ml-3 text-base">Loading...</span>
                        </div>
                        <div v-if="! loading">
                            <div v-if="$store.getters.projectsSortedBy('name').length" class="flex items-center">
                                <select v-if="! loading" @change="loadProject" v-model="selectedProjectId" class="mt-0 form-select text-sm font-medium">
                                    <option value="">Select a Project</option>
                                    <option v-for="project in $store.getters.projectsSortedBy('name')" :value="project.id" :key="project.id">{{ project.name }}</option>
                                </select>
                                <select v-if="! loading && selectedProjectId" @change="loadScenario" v-model="ksds.selectedScenarioId" class="ml-2 mt-0 form-select text-sm font-medium">
                                    <option value="">KSD Scenario</option>
                                    <option v-for="scenario in ksds.scenarios" :value="scenario.id" :key="scenario.id">{{ scenario.name }}</option>
                                </select>
                            </div>
                            <div v-else>
                                No Projects Found
                            </div>
                        </div>
                    </div>
                    <button @click="$store.dispatch('saveMap')" class="hidden btn btn-small btn-blue">Save Map</button>
                </div>
                <div class="flex items-center">
                    <span class="min-w-fit font-medium">Sort By:</span>
                    <select v-if="reatlas.layout == 'site'" v-model="sortBy" class="ml-2 mt-0 form-select">
                        <option value="item.building.address_line_1">Address</option>
                        <option value="item.utilization">Utilization</option>
                        <option value="item.current_psf">Price PSF</option>
                        <option value="item.size">Size</option>
                    </select>
                    <select v-if="reatlas.layout == 'projects'" v-model="sortBy" class="ml-2 mt-0 form-select">
                        <option value="item.address_line_1">Address</option>
                        <option value="item.pivot.score">Score</option>
                        <option value="item.pivot.ask_price">Ask PSF</option>
                        <option value="item.total_square_footage">Size</option>
                    </select>
                    <button @click="toggleSortDirection" class="ml-2">
                        <svg v-if="sortDirection == 'asc'" class="w-6 h-6 stroke-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25" />
                        </svg>
                        <svg v-if="sortDirection == 'desc'" class="w-6 h-6 stroke-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="flex h-full max-h-full">
            <div class="side-panel">
                <div id="directions-container" v-if="reatlas.layers.directions.isOn" class="border-b pb-3 min-w-[350px] max-w-[350px] border-r border-gray-300">
                <GoogleMapDirectionsContainer v-if="reatlas.layers.directions.isOn" />
            </div>
            <div id="cresiteiq-container"  class="hidden min-w-[350px] max-w-[350px] border-r border-gray-300">
                <cre-site-iq-filters v-if="reatlas.map"></cre-site-iq-filters>
            </div>
            </div>

            <div class="relative flex flex-1 flex-col">
                <button
                    v-show="creSiteIQ.isCollapsed && reatlas.layers.cresiteiq.isOn"
                    type="button"
                    id="cresiteiq-toggle"
                    @click="$store.dispatch('showCRESiteIQWindow')"
                    class="absolute top-28 bg-blue-900 p-3 flex items-center gap-x-2 z-50 rounded-r-lg"
                >
                    <span class="text-sm font-semibold text-white">CRESiteIQ&trade;</span>
                    <inline-svg name="chevron-right" classes="w-4 h-4 fill-current text-white"></inline-svg>
                </button>
                <button
                    type="button"
                    v-show="layers.cresiteiq.isOn"
                    @click="$store.dispatch('remapCRESiteIQData')"
                    class="absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full text-sm font-bold py-2 px-4 border shadow-md max-w-fit z-50 bg-white"
                    :disabled="canLoadCRESiteIQ"
                    :class="canLoadCRESiteIQ != 'disabled'
                        ? 'text-blue-600 border-blue-400 hover:text-blue-500 hover:shadow-lg hover:scale-105'
                        : 'text-gray-500 border-gray-400 animate-pulse'
                    "
                >
                    {{ canLoadCRESiteIQ != 'disabled' ? 'Reload CRESiteIQ&trade; Data' : 'Must zoom in more' }}
                </button>
                <div id="map" class="h-full w-full" @mousemove="onMapMouseMove" @mouseleave="onMapMouseLeave"></div>
                <!-- Floating Tooltip for Directions Mode -->
                <div
                  v-if="showDirectionTooltip"
                  :style="tooltipStyle"
                  class="fixed pointer-events-none z-[2000] px-3 py-1 rounded bg-blue-900 text-white text-xs font-semibold shadow-lg border border-blue-300"
                >
                  {{ directionTooltipText }}
                </div>
                <div style="z-index: 1000;" class="absolute top-3 w-full left-0 flex flex-row gap-x-4 ">
                    <div class="flex flex-row bg-white rounded-md  items-center mx-auto">
                        <div v-show="layers.cresiteiq.isOn" class="p-3 flex flex-row">
                        <div class="space-x-4 flex flex-row">
                            <div class="flex  px-3  items-center">
                                <input v-model="creSiteIQ.boundary" id="state-boundary" name="state_boundary" value="state" type="radio" class="relative w-4 h-4 hover:cursor-pointer appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden">
                                <label for="state-boundary" class="ml-3 mb-0 block text-sm/6 font-semibold text-gray-800">State</label>
                            </div>
                            <div class="flex  px-3  items-center">
                                <input v-model="creSiteIQ.boundary" id="zip-boundary" name="notification-method" value="zip" type="radio" class="relative w-4 h-4 hover:cursor-pointer appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden">
                                <label for="zip-boundary" class="ml-3 mb-0 block text-sm/6 font-semibold text-gray-800">Zip</label>
                            </div>
                        </div>
                        </div>
                        <reatlas-radius-rings />
                        <reatlas-layers />                 
                    </div>
                </div>
                <button
                    v-if="layers.airports.isOn"
                    type="button"
                    @click="layers.airports.showFilters = ! layers.airports.showFilters"
                    id="airport-filter-container"
                    class="group p-2 absolute top-2 right-14 bg-white hover:bg-gray-100 rounded-md z-50"
                >
                    <img class="w-7 h-7" src="/img/theme/v1/icons/airplane.svg" alt="Airport Icon "/>
                </button>
                <div v-if="layers.airports.showFilters" class="absolute top-14 right-14 px-6 py-5 flex flex-col space-y-8 bg-white">
                    <div class="flex flex-col">
                        <div class="flex flex-col space-y-6">
                            <div class="flex flex-col gap-y-2">
                                <label for="minimum_airport_length">Min Airport Length - {{ layers.airports.minimumAirportLength | number }}</label>
                                <input
                                    @change="filterAirports"
                                    class="range-blue"
                                    v-model="layers.airports.minimumAirportLength"
                                    type="range"
                                    name="minimum_airport_length"
                                    min="0"
                                    max="18000"
                                    step="500" />
                            </div>

                            <div class="flex flex-col gap-y-2">
                                <label for="minimum_airport_width">Min Airport Width - {{ layers.airports.minimumAirportWidth | number }}</label>
                                <input
                                    @change="filterAirports"
                                    class="range-blue"
                                    v-model="layers.airports.minimumAirportWidth"
                                    type="range"
                                    name="minimum_airport_length"
                                    min="0"
                                    max="500"
                                    step="50" />
                            </div>

                            <div class="flex items-center space-x-2">
                                <span class="text-gray-700 text-sm">Total Airports:</span>
                                <span class="text-gray-800 font-semibold">{{ layers.airports.isOn ? $store.getters.filteredAirports.length : '-' }}</span>
                            </div>
                        </div>
                    </div>

                    <button @click="layers.airports.showFilters = false" class="p-2 w-full bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-lg shadow-md">
                        Close
                    </button>
                </div>

                 <!-- Protest Filters -->
                 <div v-if="layers.protests.isOn" id="protest-filters-container" class="p-3 absolute bottom-3 left-1/2 -translate-x-1/2 bg-white rounded-md z-50 min-w-[800px]">
                    <div class="flex justify-between items-center mb-1">
                        <h3 class="text-sm font-semibold">Protest Filters</h3>
                        <button 
                            v-if="hasActiveProtestFilters"
                            @click="clearProtestFilters"
                            class="text-sm px-3 font-semibold rounded-md text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
                        >
                            Clear
                        </button>
                    </div>
                    <ProtestFilters 
                        ref="protestFilters" 
                        @clear="onProtestFiltersCleared"
                    />
                </div>

                <div v-show="layers.travel_time.isOn" id="travel-time-container" class="p-3 absolute bottom-3 left-1/2 -translate-x-1/2 bg-white rounded-md z-50 min-w-[500px]">
                    <div class="flex items-center">
                        <div class="w-full flex justify-between">
                            <div class="flex flex-1 items-center">
                                <p class="text-sm font-bold">Travel Time</p>
                                <div class="ml-3 flex items-center gap-x-2">
                                    <button
                                        @click="layers.travel_time.parameters.travel_type = 'walking'"
                                        class="p-1 rounded-full"
                                        :class="{ 'bg-blue-200': layers.travel_time.parameters.travel_type == 'walking' }">
                                        <img class="w-5" src="/img/map/directions-walk.png" />
                                    </button>
                                    <button
                                        @click="layers.travel_time.parameters.travel_type = 'driving'"
                                        class="p-1 rounded-full"
                                        :class="{ 'bg-blue-200': layers.travel_time.parameters.travel_type == 'driving' }">
                                        <img class="w-5" src="/img/map/directions-car.png" />
                                    </button>
                                    <button
                                        @click="layers.travel_time.parameters.travel_type = 'public_transport'"
                                        class="p-1 rounded-full"
                                        :class="{ 'bg-blue-200': layers.travel_time.parameters.travel_type == 'public_transport' }">
                                        <img class="w-5" src="/img/map/directions-transit.png" />
                                    </button>
                                    <button
                                        @click="layers.travel_time.parameters.travel_type = 'cycling'"
                                        class="p-1 rounded-full"
                                        :class="{ 'bg-blue-200': layers.travel_time.parameters.travel_type == 'cycling' }">
                                        <img class="w-5" src="/img/map/directions-bike.png" />
                                    </button>
                                </div>
                            </div>
                            <div class="flex items-center">
                                <select @change="fetchTravelTime" v-model="layers.travel_time.parameters.arrive_or_depart" class="ml-2 mt-0 form-select">
                                    <option value="depart">Depart</option>
                                    <option value="arrive">Arrive</option>
                                </select>
                                <select @change="fetchTravelTime" v-model="layers.travel_time.parameters.arrive_or_depart_time" class="ml-2 mt-0 form-select">
                                    <option value=""></option>
                                    <option value="5">5:00 AM</option>
                                    <option value="6">6:00 AM</option>
                                    <option value="7">7:00 AM</option>
                                    <option value="8">8:00 AM</option>
                                    <option value="9">9:00 AM</option>
                                    <option value="10">10:00 AM</option>
                                    <option value="11">11:00 AM</option>
                                    <option value="12">12:00 PM</option>
                                    <option value="13">1:00 PM</option>
                                    <option value="14">2:00 PM</option>
                                    <option value="15">3:00 PM</option>
                                    <option value="16">4:00 PM</option>
                                    <option value="17">5:00 PM</option>
                                    <option value="18">6:00 PM</option>
                                    <option value="19">7:00 PM</option>
                                    <option value="20">8:00 PM</option>
                                    <option value="21">9:00 PM</option>
                                    <option value="22">10:00 PM</option>
                                    <option value="23">11:00 PM</option>
                                    <option value="24">12:00 AM</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1.5 flex items-center">
                        <div class="flex items-center gap-x-2">
                            <label class="mb-0" for="travel_time">Within</label>
                            <select @change="fetchTravelTime" v-model="layers.travel_time.parameters.travel_time" class="mt-0 form-select">
                                <option value="900">15 min</option>
                                <option value="1800">30 min</option>
                                <option v-if="['driving', 'public_transport'].includes(layers.travel_time.parameters.travel_type)" value="3600">1 hr</option>
                                <option v-if="['driving', 'public_transport'].includes(layers.travel_time.parameters.travel_type)" value="5400">1.5 hr</option>
                                <option v-if="['driving', 'public_transport'].includes(layers.travel_time.parameters.travel_type)" value="7200">2 hr</option>
                            </select>
                            <label class="mb-0" for="travel_time">of</label>
                            <select @change="fetchTravelTime" v-model="layers.travel_time.parameters.building_id" class="mt-0 form-select">
                                <option value=''>Select Building</option>
                                <template v-if="reatlas.layout == 'site'">
                                    <option v-for="marker in buildings" :key="marker.item.building?.id" :value="marker.item.building?.id">{{ marker.item.building?.address_line_1 }}, {{ marker.item.building?.city }}, {{ marker.item.building?.state }}</option>
                                </template>
                                <template v-if="reatlas.layout == 'projects'">
                                    <option v-for="marker in buildings" :key="marker.item.id" :value="marker.item.id">
                                        <span v-if="marker.type == 'comp'">
                                            {{ marker.item.address_line_1 }}, {{ marker.item.city }}, {{ marker.item.state }}
                                        </span>
                                        <span v-if="marker.type == 'site'">
                                            {{ marker.item.building?.address_line_1 }}, {{ marker.item.building?.city }}, {{ marker.item.building?.state }}
                                        </span>
                                    </option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>

                <div v-show="layers.heat_map.isOn" id="heat-map-container" class="p-3 absolute bottom-3 left-1/2 -translate-x-1/2 bg-white rounded-md z-50 min-w-[400px]">
                    <div class="w-full flex items-center justify-between">
                        <p class="text-sm font-bold">Heat Map</p>

                        <div class="flex items-center gap-x-2">
                            <span class="text-sm font-bold">Metric:</span>
                            <select @change="loadHeatMap" v-model="layers.heat_map.parameters.metric" class="mt-0 form-select max-w-fit">
                                <option v-for="(label, field) in reatlas.heatMapMetrics" :key="field" :value="field">{{ label }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-show="reatlas.mapLoading" class="flex items-center justify-center w-full h-full absolute inset-0 bg-gray-800/50 z-50">
                    <div class="flex items-center bg-gray-900 text-white text-lg px-5 py-6 rounded-lg gap-x-3">
                        <span class="font-medium">Updating Map...</span>
                    </div>
                </div>
            </div>

            <div id="cresiteiq-container-right" class="hidden">
                <div class="flex flex-col min-h-full max-h-full overflow-hidden bg-white shadow-md border-l border-gray-300 h-full" style="width: 350px;">
                    <div class="relative flex-1 min-h-full max-h-full overflow-y-auto">
                        <cre-site-iq-scores />
                    </div>
                </div>
            </div>

            <div id="building-list-container">
                <div v-if="reatlas.layout == 'site'" class="flex flex-col min-h-full max-h-full overflow-hidden bg-white shadow-md border-l border-gray-300" style="width: 350px;">
                    <div id="site-card-container" class="relative flex-1 min-h-full max-h-full overflow-y-auto">
                        <div v-for="marker in sortedBuildings" :key="marker.item.id" @click="showSite(marker.item)" class="flex min-h-[125px] border-b border-gray-300 reatlas-sidebar-data cursor-pointer hover:bg-yellow-50" :class="marker.item.id == selectedSite.id ? 'bg-yellow-50' : 'odd:bg-white even:bg-gray-50'">
                            <div class="p-3 flex flex-col justify-between flex-1">
                                <div class="flex-1 w-full leading-normal">
                                    <p class="text-base font-semibold">
                                        {{ marker.item.building?.address_line_1 | truncate(22) }}
                                    </p>
                                    <p class="text-sm">{{ marker.item.building?.city }}, {{ marker.item.building?.state }}</p>
                                </div>
                                <div class="flex justify-between items-center leading-normal">
                                    <div class="flex flex-col">
                                        <p data-precision="2" :data-originalvalue="marker.item.current_psf" class="is-currency text-sm">{{ formatCurrency(marker.item.current_psf, 2, null, marker.item.currency) }}</p>
                                        <p class="text-sm font-medium text-gray-900">Price PSF</p>
                                    </div>
                                    <div class="flex flex-col">
                                        <p class="text-sm">{{ marker.item.size | number }}</p>
                                        <p class="text-sm font-medium text-gray-900">Site Size</p>
                                    </div>
                                </div>
                            </div>
                            <div class="relative">
                                <div v-if="marker.item.archived_at !== null" class="absolute bottom-1 right-1 z-40" title="Site is Archived">
                                    <inline-svg name="archived"></inline-svg>
                                </div>
                                <img :src="marker.item.image?.view_url" class="w-32 h-full max-h-[125px] object-cover">
                                <div
                                    class="badge absolute right-1 top-1 p-5 w-7 h-7 flex justify-center items-center font-bold text-xs rounded-full shadow-md"
                                    :class="marker.item.utilization_color"
                                    title="Utilization"
                                >
                                   {{ marker.item.utilization }}%
                                </div>
                            </div>
                        </div>
                        <div
                            class="hidden scroll-up-indicator p-2 absolute left-1/2 -translate-x-1/2 bg-blue-200 rounded-full shadow-md"
                            :style="{'top': scrollUpIndicatorPosition + 'px' }">
                                <inline-svg name="chevron-down" classes="indicator-up-arrow rotate-180 w-4 h-4 text-white" />
                        </div>
                        <div
                            class="scroll-down-indicator p-2 absolute left-1/2 -translate-x-1/2 bg-blue-200 rounded-full shadow-md"
                            :style="{'top': scrollDownIndicatorPosition + 'px' }">
                                <inline-svg name="chevron-down" classes="indicator-down-arrow w-4 h-4 text-white" />
                        </div>
                    </div>
                    <div class="flex items-center justify-around p-3 site-title-bar text-white border-t border-gray-300 leading-normal">
                        <div class="flex flex-col items-center">
                            <p class="text-2xl font-semibold">{{ totalSites }}</p>
                            <p class="text-sm">Total Sites</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <p data-precision="2" :data-originalvalue="average_psf" class="is-currency text-2xl font-semibold" v-text="formatCurrency(average_psf, 2)"></p>
                            <p class="text-sm">Average PSF</p>
                        </div>
                    </div>
                </div>

                <div v-if="reatlas.layout == 'projects'" class="flex flex-col min-h-full max-h-full overflow-hidden bg-white shadow-md border-l border-gray-300" style="width: 365px;">
                    <div id="comp-card-container" class="relative flex-1 min-h-full max-h-full overflow-y-auto">
                        <div v-for="(marker, index) in sortedBuildings" :key="marker.item.id" @click="showComp(marker.item)" class="flex min-h-[125px] border-b border-gray-300 reatlas-sidebar-data cursor-pointer hover:bg-yellow-50" :class="marker.item.id == reatlas.selectedComp.building_id ? 'bg-yellow-50' : 'odd:bg-white even:bg-gray-50'">
                            <div class="p-3 flex flex-col flex-1">
                                <div class="flex-1 w-full leading-normal">
                                    <p v-if="! reatlas.isNegotiationMode" class="text-base font-semibold">{{ marker.item.address_line_1 | truncate(22) }}</p>
                                    <p v-else class="text-base font-semibold">Alternative Site #{{index + 1}}</p>
                                    <p class="text-sm">{{ marker.item.city }}, {{ marker.item.state }}</p>
                                </div>
                                <div class="flex justify-between items-center leading-normal">
                                    <div class="flex flex-col">
                                        <p data-precision="2" :data-originalvalue="marker.item.pivot.ask_price" class="is-currency text-base">{{ formatCurrency(marker.item.pivot.ask_price, 2, null, marker.item.currency) }}</p>
                                        <p class="text-sm font-medium text-gray-900">Ask PSF</p>
                                    </div>
                                    <div class="flex flex-col">
                                        <p class="text-base">{{ marker.item.total_square_footage | number }}</p>
                                        <p class="text-sm font-medium text-gray-900">Comp Size</p>
                                    </div>
                                </div>
                            </div>
                            <div class="relative">
                                <img :src="marker.item.image?.view_url" class="w-32 h-full max-h-[125px] object-cover">
                                <div
                                    class="absolute top-1 right-1 badge p-5 w-7 h-7 flex justify-center items-center text-white text-xs font-bold rounded-full shadow-md"
                                    :class="marker.item.pivot.score_color"
                                    title="Score"
                                >
                                   {{ marker.item.pivot.score }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="hidden scroll-up-indicator p-2 absolute left-1/2 -translate-x-1/2 bg-blue-200 rounded-full shadow-md"
                            :style="{'top': scrollUpIndicatorPosition + 'px' }">
                                <inline-svg name="chevron-down" classes="indicator-up-arrow rotate-180 w-4 h-4 text-white" />
                        </div>
                        <div
                            class="scroll-down-indicator p-2 absolute left-1/2 -translate-x-1/2 bg-blue-200 rounded-full shadow-md"
                            :style="{'top': scrollDownIndicatorPosition + 'px' }">
                                <inline-svg name="chevron-down" classes="indicator-down-arrow w-4 h-4 text-white" />
                        </div>
                    </div>
                    <div v-if="reatlas.layout == 'projects' && selectedProjectId == ''" class="flex-1 font-bold text-center text-gray-600">
                        Select a Project
                    </div>
                    <div class="flex items-center justify-around p-3 bg-gradient-to-b from-green-500 to-green-600 text-white border-t border-gray-300 leading-normal">
                        <div class="flex flex-col items-center">
                            <p class="text-2xl font-semibold">{{ totalComps }}</p>
                            <p class="text-sm">Total Comps</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <p data-precision="2" :data-originalvalue="average_ask_price_psf" class="is-currency text-2xl font-semibold" v-text="formatCurrency(average_ask_price_psf, 2)"></p>
                            <p class="text-sm">Average Ask PSF</p>
                        </div>
                    </div>
                </div>
            </div>

            <div id="right-popout-bar" class="hidden min-w-[700px] border-l border-gray-300">
                <site
                    v-if="Object.keys(selectedSite).length"
                    :data="selectedSite"
                    @reatlas-close-right-panel="hideSideBar"
                    from-reatlas>
                </site>
                <comp
                    v-if="reatlas.layout == 'projects' && Object.keys(reatlas.selectedComp).length"
                    :project-data="projects.selectedProject"
                    :comp-data="reatlas.selectedComp"
                    @reatlas-close-right-panel="hideSideBar"
                    from-reatlas>
                </comp>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>

        <!-- Layer & marker popups (v1 style) -->
        <AirportPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'airport'"
            :airport="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <PortPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'port'"
            :port="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <WaterwayPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'waterway'"
            :waterway="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <RailPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'rail'"
            :rail="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <HighwayPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'highway'"
            :highway="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <WildfirePopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'wildfire'"
            :wildfire="reatlas.activePopup && reatlas.activePopup.data"
            @close="$store.commit('clearActivePopup')"
        />
        <ProtestPopup
            :show="reatlas.activePopup && reatlas.activePopup.type === 'protest'"
            :protest="reatlas.activePopup && reatlas.activePopup.data"
            :filters="reatlas.protestFilters || {}"
            @close="$store.commit('clearActivePopup')"
        />
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import { Loader } from "@googlemaps/js-api-loader";
    import InlineSvg from "../InlineSvg";
    import GoogleMapDirectionsContainer from '../cresiteiq/GoogleMapDirectionsContainer.vue';
    import AirportPopup   from '../theme/v1/cresiteiq2/AirportPopup.vue';
    import PortPopup      from '../theme/v1/cresiteiq2/PortPopup.vue';
    import WaterwayPopup  from '../theme/v1/cresiteiq2/WaterwayPopup.vue';
    import RailPopup      from '../theme/v1/cresiteiq2/RailPopup.vue';
    import HighwayPopup   from '../theme/v1/cresiteiq2/HighwayPopup.vue';
    import WildfirePopup  from '../theme/v1/cresiteiq2/WildfirePopup.vue';
    import ProtestPopup   from '../theme/v1/cresiteiq2/ProtestPopup.vue';

    export default {
        name: 'ReoptReatlas',

        components: {
            InlineSvg,
            GoogleMapDirectionsContainer,
            AirportPopup,
            PortPopup,
            WaterwayPopup,
            RailPopup,
            HighwayPopup,
            WildfirePopup,
            ProtestPopup,
        },
        props: {
            setMode: {
                type: String,
                required: true
            },

            siteData: {
              type: Array,
              required: false
            },

            selectedViewOption: {
                type: String,
                default: 'site'
            },

            loadProjectId: {
                type: Number,
                required: false
            },

            setZoom: {
              type: Number,
              default: 6
            },

            showFilters: {
              type: Boolean,
              default: true
            },

            showArchivedSites: {
                type: Boolean,
                default: false
            },

            loadSavedMapId: {
                type: Number,
                required: false
            }
        },

        data() {
            return {
                loader: null,
                mode: this.setMode,
                selectedProjectId: this.loadProjectId || "",
                center: { lat: 39.8097343, lng: -98.5556199 },
                // center: { lat: 27.9510639, lng: -82.4527575 },
                rotation: 0,
                zoom: this.setZoom,
                // zoom: 10,
                loading: false,
                scrollUpIndicatorPosition: 0,
                scrollDownIndicatorPosition: 0,
                sortBy: "item.building.address_line_1",
                sortDirection: 'asc',
                tooltipX: 0,
                tooltipY: 0,
                tooltipVisible: false,
            }
        },

        async mounted() {
            // this.$store.dispatch('fetchCurrentUser').then(() => {
            //     localStorage.setItem(`reopt_baseCurrency`, this.users.selectedUser.country.currency.code);

            //     this.$eventHub.$emit('convert-currency');
            // });

            this.reatlas.layout = this.selectedViewOption;

            this.loader = new Loader({
              apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
              version: "quarterly",
              libraries: ["places"]
            });

            document.querySelector("html").classList.add('overflow-x-hidden');

            this.reatlas.sites.all = this.siteData
            this.reatlas.sites.filtered = this.siteData.filter(site => {
                return site.archived_at == null;
            });

            await this.initMap();

            if (this.loadSavedMapId != null) {
                this.$store.dispatch('loadMap', this.loadSavedMapId);
            }

            this.$store.dispatch('loadStates');

            this.$nextTick(async () => {
                this.initScrollListener();
                this.setScrollIndicatorPosition();
                await this.$store.dispatch('addMarkers', { data: this.reatlas.sites.filtered, type: 'site' });
                this.$emit('filterRequest');

                this.reatlas.mapLoading = false;
            })
        },

        watch: {
            'layers.travel_time.parameters.travel_type'() {
                this.$store.dispatch('fetchTravelTime');
            },

            'reatlas.filteredMarkers'() {
                if (this.reatlas.layout == 'site') {
                    var div = document.getElementById('site-card-container');
                } else if (this.reatlas.layout == 'projects') {
                    div = document.getElementById('comp-card-container');
                }

                if (! div) {
                    return;
                }

                div.dispatchEvent(new CustomEvent('scroll'));
            },

            'reatlas.shapes'() {
                this.$store.dispatch('hideBuildingsNotInShapes');

                this.$store.dispatch('syncBuildings');
            },

            'ksds.selectedScenarioId'() {
                this.recalculateCompScores();
            },

            selectedSite() {
                this.$store.dispatch('panTo', this.selectedSite.building_id);
            },

            selectedComp() {
                if (this.selectedComp.building_id) {
                    _.debounce(() => {
                        this.$store.dispatch('panTo', this.selectedComp.building_id);
                    }, 100)();
                }
            },

            'creSiteIQ.boundary'() {
                this.$store.dispatch('remapCRESiteIQData');
                // this.creSiteIQ.data = null;
                // this.$store.dispatch('loadCRESiteIQData');
            }
        },

        computed: {
            hasActiveProtestFilters() {
                const { selectedFactors = [], searchText = '', dateRange = null } = this.reatlas.protestFilters || {};
                return selectedFactors.length > 0 || 
                       (searchText && searchText.trim() !== '') || 
                       (dateRange && (dateRange.startDate || dateRange.endDate));
            },
            ...mapState(['users']),
            ...mapState(['reatlas']),
            ...mapState(['creSiteIQ']),
            ...mapState(['projects']),
            ...mapState(['ksds']),
            ...mapGetters(['addedMarkers', 'scenario', 'scenarioKsds']),
            ...mapActions(['addMarkers', 'addMarker', 'centerWithBounds']),

            map() {
                return this.reatlas.map;
            },

            selectedSite() {
                return this.reatlas.selectedSite;
            },

            selectedComp() {
                return this.reatlas.selectedComp;
            },

            filters() {
                return {
                    showArchivedSites: this.showArchivedSites
                }
            },

            sortedBuildings() {
                let buildings = this.reatlas.filteredMarkers.filter(marker =>
                    ['site', 'comp'].includes(marker.type)
                );

                // If layout is 'projects', only include comps
                if (this.reatlas.layout === 'projects') {
                    buildings = buildings.filter(marker => marker.type === 'comp');
                }

                // Deduplicate by item.id + type
                const uniqueMap = new Map();
                for (const b of buildings) {
                    uniqueMap.set(`${b.item.id}-${b.type}`, b);
                }

                return _.orderBy(
                    [...uniqueMap.values()],
                    building => _.at(building, this.sortBy)[0],
                    this.sortDirection
                );
            },

            layers() {
                return this.reatlas.layers;
            },

            buildings() {
                var buildings = _.filter(this.reatlas.filteredMarkers, marker => marker.type != 'employee');

                return _.orderBy(buildings, building => _.at(building, 'item.building.address_line_1')[0], 'asc');
            },

            totalSites() {
                return _.filter(this.reatlas.filteredMarkers, marker => marker.type == 'site').length || 0;
            },

            totalComps() {
                return _.filter(this.reatlas.filteredMarkers, marker => marker.type == 'comp').length || 0;
            },

            average_psf() {
                return _.meanBy(_.filter(this.reatlas.filteredMarkers, marker => marker.type == 'site'), marker => marker.item.current_psf);
            },

            average_ask_price_psf() {
                if (! this.reatlas.filteredMarkers) {
                    return 0;
                }

                return _.meanBy(_.filter(this.reatlas.filteredMarkers, marker => marker.type == 'comp'), (comp) => {
                    return comp.item.pivot.ask_price;
                });
            },

            selectedCurrency() {
                return localStorage.getItem(`reopt_selectedCurrency`);
            },

            canLoadCRESiteIQ() {
                if (this.map?.getZoom() <= this.creSiteIQ.minZoom) {
                    return 'disabled';
                }
                return null;
            },

            showDirectionTooltip() {
                return this.reatlas.layers.directions.isOn && this.tooltipVisible;
            },
            directionTooltipText() {
                if (!this.reatlas.directions.stops[0] || !this.reatlas.directions.stops[0].latLng) {
                    return 'Click to select Origin';
                } else {
                    return 'Click to select Destination';
                }
            },
            tooltipStyle() {
                return {
                    left: this.tooltipX + 16 + 'px',
                    top: this.tooltipY + 16 + 'px',
                    position: 'fixed',
                    pointerEvents: 'none',
                    transition: 'left 0.05s, top 0.05s',
                };
            },
        },

        methods: {
            // Clear protest filters from parent component
            clearProtestFilters() {
                if (this.$refs.protestFilters) {
                    // Call the clearFilters method on the ProtestFilters component
                    const filters = this.$refs.protestFilters.clearFilters();
                    
                    // Apply the cleared filters to the map
                    if (window.applyProtestMapFilters) {
                        window.applyProtestMapFilters(filters);
                    }
                }
            },
            
            // Handle the clear event from ProtestFilters component
            onProtestFiltersCleared() {
                // Additional handling when filters are cleared, if needed
                console.log('Protest filters were cleared');
            },
            
            async initMap() {
                this.loader.load().then(async () => {
                    const { Map, InfoWindow } = await google.maps.importLibrary("maps");

                    this.reatlas.map = new Map(document.getElementById("map"), {
                        center: this.center,
                        zoom: this.zoom,
                        zoomControlOptions:       { position: google.maps.ControlPosition.LEFT_BOTTOM },
                        mapTypeControlOptions:    { position: google.maps.ControlPosition.LEFT_TOP },
                        streetViewControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
                        fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
                        scaleControlOptions:      { position: google.maps.ControlPosition.LEFT_BOTTOM },
                        mapId: "REOPTIMIZER_REATLAS_V2"
                    });

                    this.reatlas.infoWindow = new InfoWindow({ headerDisabled: true });

                    this.reatlas.map.addListener("dragend", async () => {
                        this.$store.dispatch('hideBuildingsNotInBounds');

                        if (this.reatlas.layers.cresiteiq.isOn) {
                            this.$store.dispatch('refreshScores');
                        }
                    });

                    this.reatlas.map.addListener("zoom_changed", async () => {
                        if (this.reatlas.layers.cresiteiq.isOn) {
                            this.$store.dispatch('refreshScores');
                        }
                    });

                    this.$store.dispatch('initDataLayerListeners');

                    this.reatlas.map.addListener("idle", () => {
                        if (this.reatlas.heatMap != null) {
                            let zoom = this.reatlas.map.getZoom();

                            var radius = null;
                            var maxIntensity = 0;
                            var opacity = 0.5;

                            if (zoom < 5) {
                                maxIntensity = 500;
                                radius = 20;
                            } else if (zoom == 5) {
                                radius = 20;
                            } else if (zoom == 6) {
                                radius = 30;
                            } else if (zoom == 7) {
                                radius = 50;
                            } else if (zoom == 8) {
                                radius = 100;
                            } else if (zoom == 9) {
                                radius = 150;
                            } else if (zoom == 10) {
                                radius = 200;
                            } else if (zoom == 11) {
                                radius = 400;
                            } else if (zoom == 12) {
                                radius = 700;
                                opacity = 0.4;
                            } else {
                                radius = 1000;
                            }

                            this.reatlas.heatMap.setOptions({ radius: radius, maxIntensity: maxIntensity, opacity: opacity });
                            // this.reatlas.heatMap.setOptions({ dissipating: this.reatlas.map.getZoom() <= 6 ? true : false });
                        }
                        this.$store.dispatch('hideBuildingsNotInBounds');
                    });

                    this.initDrawingManager();

                    if (this.mode == 'cresiteiq') {
                        this.$store.dispatch('toggleLayer', 'cresiteiq');
                    }
                });

                window.closeInfoBubble = () => this.closeInfoBubble();
                window.closeCRESiteIQInfoBubble = () => this.closeCRESiteIQInfoBubble();
                window.showSite = () => this.showSite();
                window.showComp = () => this.showComp();
                window.toggleRadius = (el) => this.toggleRadius(el);
                window.toggleLayer = (layerKey) => this.$store.dispatch('toggleLayer', layerKey);
            },

            async initDrawingManager() {
                // Google removed DrawingManager in Maps JS 3.65. The loader is pinned to the
                // quarterly channel, which still has it, but that channel will roll forward.
                // Degrade to "no drawing tools" rather than an unhandled rejection.
                try {
                    await google.maps.importLibrary("drawing");

                    this.reatlas.drawingManager = new google.maps.drawing.DrawingManager({
                        drawingControl: true,
                        drawingControlOptions: {
                            position: google.maps.ControlPosition.LEFT_BOTTOM,

                            drawingModes: [
                                google.maps.drawing.OverlayType.CIRCLE,
                                google.maps.drawing.OverlayType.POLYGON,
                                google.maps.drawing.OverlayType.RECTANGLE,
                            ],
                        },
                        circleOptions: {
                            strokeColor: "#2563eb",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#60a5fa",
                            fillOpacity: 0.35,
                            clickable: true,
                            editable: true,
                            zIndex: 1,
                        },
                        polygonOptions: {
                            strokeColor: "#2563eb",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#60a5fa",
                            fillOpacity: 0.35,
                            clickable: true,
                            editable: true,
                            zIndex: 1,
                        },
                        rectangleOptions: {
                            strokeColor: "#2563eb",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#60a5fa",
                            fillOpacity: 0.35,
                            clickable: true,
                            editable: true,
                            zIndex: 1,
                        },
                    });

                    this.reatlas.drawingManager.setMap(this.reatlas.map);

                    google.maps.event.addListener(this.reatlas.drawingManager, 'overlaycomplete', shape => {
                        this.$store.dispatch('addShape', shape);
                    });
                } catch (error) {
                    console.warn("Drawing tools unavailable:", error && error.message);
                }
            },

            initScrollListener() {
                let upIndicators = document.getElementsByClassName('scroll-up-indicator');
                let downIndicators = document.getElementsByClassName('scroll-down-indicator');

                if (this.reatlas.layout == 'site') {
                    var div = document.getElementById('site-card-container');
                } else if (this.reatlas.layout == 'projects') {
                    div = document.getElementById('comp-card-container');
                }

                div.addEventListener("scroll", () => {
                    if (div.scrollTop == 0) {
                        upIndicators.forEach((indicator) => {
                            indicator.classList.add('hidden');
                        });
                    } else {
                        upIndicators.forEach((indicator) => {
                            indicator.classList.remove('hidden');
                        });
                    }

                    if (this.reatlas.filteredMarkers.length < 7 || (div.scrollTop != 0 && (div.scrollHeight - div.scrollTop == div.clientHeight))) {
                        downIndicators.forEach((indicator) => {
                            indicator.classList.add('hidden');
                        });
                    } else {
                        downIndicators.forEach((indicator) => {
                            indicator.classList.remove('hidden');
                        });
                    }

                    this.setScrollIndicatorPosition();
                });

                window.addEventListener("resize", () => {
                    this.setScrollIndicatorPosition();
                });
            },

            setScrollIndicatorPosition() {
                if (this.reatlas.layout == 'site') {
                    var div = document.getElementById('site-card-container');
                } else if (this.reatlas.layout == 'projects') {
                    div = document.getElementById('comp-card-container');
                }

                this.scrollUpIndicatorPosition = div.scrollTop + 10;
                this.scrollDownIndicatorPosition = div.scrollTop + div.clientHeight - 40;
            },

            async setView(type) {
                this.hideSideBar();
                this.closeInfoBubble();

                if (type == 'projects') {
                    this.sortBy = 'item.pivot.score';
                    this.sortDirection = 'desc';
                    // document.getElementsByClassName('scroll-down-indicator').forEach(indicator => {
                    //     indicator.classList.add('hidden');
                    // });

                    this.loading = true;
                    this.$store.dispatch('loadProjects').then(() => {
                        this.loading = false;
                    });

                    this.updatePageTitle('Projects')

                    var dataset = this.projects.selectedProject.comps;
                } else {
                    this.selectedProjectId = '';
                    this.sortBy = 'item.building.address_line_1';
                    this.sortDirection = 'asc';

                    this.updatePageTitle('Sites')

                    dataset = this.reatlas.sites.filtered;
                }

                this.reatlas.layout = type;

                this.$store.dispatch('removeMarkersByType', 'site');
                this.$store.dispatch('removeMarkersByType', 'comp');
                this.$store.dispatch('removeCircles');
                this.$store.dispatch('removePolygonsByType', 'travel_time');

                this.reatlas.layers.travel_time.parameters.building_id = '';

                await this.$store.dispatch('addMarkers', { data: dataset, type: type });

                this.$store.dispatch('centerWithBounds');
            },

            closeInfoBubble() {
                this.reatlas.selectedComp = {};

                this.reatlas.infoWindow.close();
                this.hideSideBar();
            },

            closeCRESiteIQInfoBubble() {
                this.$store.dispatch('resetFeatures');
                this.reatlas.infoWindow.close();
            },

            showSite(site) {
                let data = site || this.reatlas.featureData;

                this.showSideBar();

                this.reatlas.selectedComp = {};
                this.reatlas.selectedSite = data;

                this.updatePageTitle(data.building.address_line_1);
            },

            showComp(comp) {
                let data = comp || this.reatlas.featureData;

                this.showSideBar();

                this.reatlas.selectedSite = {};
                this.reatlas.selectedComp = data.pivot;
                this.reatlas.selectedComp.building = data;

                this.updatePageTitle(data.address_line_1);
            },

            toggleRadius(el) {
                let circle = _.find(this.reatlas.circles, circle => {
                    return circle.marker.building_id == this.reatlas.featureData.building_id;
                });

                let circleIcon = el.getElementsByTagName('span')[0];

                if (circle) {
                    el.classList.remove('bg-gray-500', 'hover:bg-blue-100');
                    el.classList.add('bg-gray-100', 'hover:bg-blue-500');
                    circleIcon.classList.add('border-blue-400', 'group-hover:border-white');
                    circleIcon.classList.remove('border-white', 'group-hover:border-gray-500');

                    circle.ring.setMap(null);
                    this.reatlas.circles = _.remove(this.reatlas.circles, circle => {
                        return circle.marker.building_id != this.reatlas.featureData.building_id;
                    });
                } else {
                    el.classList.remove('bg-gray-100', 'hover:bg-blue-500');
                    el.classList.add('bg-blue-500', 'hover:bg-gray-100');
                    circleIcon.classList.add('border-white', 'group-hover:border-gray-500');
                    circleIcon.classList.remove('border-blue-400', 'group-hover:border-white');

                    this.$store.dispatch('drawCircle', {
                        item: this.reatlas.featureData,
                        position: {
                            lat: this.reatlas.featureData.building?.latitude || this.reatlas.featureData.latitude,
                            lng: this.reatlas.featureData.building?.longitude || this.reatlas.featureData.longitude,
                        },
                        miles: 10
                    });
                }
            },

            async loadProject() {
                this.hideSideBar();

                this.loading = true;

                await this.$store.dispatch('loadProject', this.selectedProjectId);

                this.ksds.scenarios = this.projects.selectedProject.ksd_scenarios;

                let defaultScenario = _.find(this.ksds.scenarios, ['is_default', 1]);

                this.ksds.selectedScenarioId = defaultScenario ? defaultScenario.id : this.ksds.scenarios[0].id;
                this.reatlas.isNegotiationMode = this.scenario.negotiation_mode;

                this.updatePageTitle(this.projects.selectedProject.name);

                this.$store.dispatch('removeMarkersByType', 'site');
                this.$store.dispatch('removeMarkersByType', 'comp');

                await this.$store.dispatch('addMarkers', { data: this.projects.selectedProject.comps, type: 'comp' });

                await this.$store.dispatch('addMarkers', { data: this.projects.selectedProject.sites, type: 'site' });

                await this.$store.dispatch('showMarkersInBounds');

                this.$store.dispatch('centerWithBounds');

                this.loading = false;
            },

            async loadScenario() {
                if (! this.scenario) {
                    return;
                }

                this.reatlas.isNegotiationMode = this.scenario.negotiation_mode;

                this.reatlas.infoWindow.close();
            },

            recalculateCompScores() {
                _.each(this.reatlas.filteredMarkers, comp => {
                    comp.item.pivot.score = this.calculateCompScore(comp.item.pivot.id);
                    comp.item.pivot.score_badge_color = this.getScoreBadgeColor(comp.item.pivot.score);
                    comp.item.pivot.score_color = this.getScoreColor(comp.item.pivot.score);
                });
            },

            calculateCompScore(compId) {
                var compScore = 0;
                const priceKSD = _.find(this.scenarioKsds, ['driver', 'Price']);
                const priceWeight = priceKSD ? parseInt(priceKSD.weight) : 0;

                _.map(this.scenarioKsds, ksd => {
                    let scoreRecord = _.find(ksd.scores, ['scorable_id', compId]);
                    const score = scoreRecord ? parseInt(scoreRecord['score']) : 0;
                    const weight = parseInt(ksd.weight);
                    const divisble = 100 - priceWeight;

                    const scorePercentage = score * 20;
                    const weightedScore = (scorePercentage * weight) / divisble;

                    compScore += weightedScore;
                });

                compScore = Math.round(compScore);

                return compScore > 100 ? 100 : compScore;
            },

            getScoreColor(score) {
                return (score < 70 ? 'bg-red-500' : (score >= 90 ? 'bg-green-500' : 'bg-yellow-200 text-yellow-700'));
            },

            getScoreBadgeColor(score) {
                if (score < 70) {
                    return 'badge-red';
                }

                if (score >= 90) {
                    return 'badge-green';
                }

                if (score >= 70) {
                    return 'badge-yellow';
                }

                return 'badge-red';
            },

            updatePageTitle(title) {
                document.title = 'REatlas - ' + title;
            },

            showSideBar() {
                document.getElementById('right-popout-bar').classList.remove('hidden');
            },

            hideSideBar() {
                document.getElementById('right-popout-bar').classList.add('hidden');

                this.reatlas.selectedComp = {};
                this.reatlas.selectedSite = {};
            },

            toggleSortDirection() {
                this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
            },

            fetchTravelTime() {
                this.$store.dispatch('fetchTravelTime');
            },

            loadHeatMap() {
                this.$store.dispatch('loadHeatMapData');
            },

            filterAirports() {
                this.$store.dispatch('removeMarkersByType', 'airport');
                this.$store.dispatch('addMarkers', { data: this.$store.getters.filteredAirports, type: 'airport' });
            },

            onMapMouseMove(e) {
                this.tooltipX = e.clientX;
                this.tooltipY = e.clientY;
                this.tooltipVisible = true;
            },
            onMapMouseLeave() {
                this.tooltipVisible = false;
            },
        }
    }
</script>
